module.exports = __webpack_public_path__ + "static/media/reviewedstamp.cc275486.svg";